import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';

/* ─────────────────────────────────────────
 * MODELS
 * ───────────────────────────────────────── */

export interface FileUploadResponse {
  ruta: string;
}

export interface FileDeleteRequest {
  fullPath: string;
  files: string[];
}

/* ─────────────────────────────────────────
 * SERVICE
 * ───────────────────────────────────────── */

@Injectable({
  providedIn: 'root',
})
export class FileServerService {
  private readonly baseUrl = environment.HOST;

  constructor(private http: HttpClient) {}

  // ─────────────────────────────────────
  // SUBIR ARCHIVO
  // ─────────────────────────────────────
  subirArchivo(file: File): Observable<string> {
    const formData = new FormData();
    formData.append('file', file);

    return this.http.post(
      `${this.baseUrl}${URL_MAP.API.FILE_UPLOAD}`,
      formData,
      { responseType: 'text' },
    );
  }

  // ─────────────────────────────────────
  // ELIMINAR ARCHIVOS
  // ─────────────────────────────────────
  eliminarArchivos(fullPath: string, files: string[]): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}${URL_MAP.API.FILE_DELETE}`, {
      params: { fullPath },
      body: files,
    });
  }

  // ─────────────────────────────────────
  // DESCARGAR ARCHIVO
  // ─────────────────────────────────────
  descargarArchivo(fullPath: string): Observable<Blob> {
    return this.http.post(
      `${this.baseUrl}${URL_MAP.API.FILE_DOWNLOAD}`,
      fullPath,
      { responseType: 'blob' },
    );
  }
}
